import Component from "../component.abstract";
import { getAnyInstancesByElement } from "../../core";
import GlobalEvent from "./global-event";

export interface TrackEventProps {
    [index: string]: any;
}

export default class TrackEvent extends Component {
    private events: Array<any>;

    constructor (
        private props: TrackEventProps,
        element: HTMLElement
    ) {
        super(props, element);

        this.events = [];

        if (!props.events) {
            this.events.push(props);
        } else {
            this.events = props.events;
        }
    }

    mounted(): void {
        this.track()
    }

    public setList(list: string): void {
        if (this.props?.ecommerce?.click?.actionField?.list) {
            this.props.ecommerce.click.actionField.list = list;
        }
    }

    public track(): void {
        // Get all instances on this element with enableTracking function
        const instances: Array<Component> = getAnyInstancesByElement(this.element).filter(instance => {
            return (<any> instance).enableTracking;
        });

        if (instances.length) {
            instances.forEach(instance => {
                // Launch specific tracking function if needed
                (<any> instance).enableTracking(this.props, this);
            });
        } else {
            this.addEvents(this.events);
        }
    }

    /**
     * Create the events
     * It can be called by other instances 
     */
    addEvents(events: Array<any>): void {
        events.forEach((event: any) => {
            new GlobalEvent(event, this);
        });
    }
}